import { useTranslations } from '@vocab/react';

import { getOptionText } from 'src/app/utils/getOptionText';
import { WorkArrangement } from 'src/graphql/generated';

import translations from './.vocab';

export const useWorkArrangementTaxonomy = () => {
  const { t } = useTranslations(translations);

  const workArrangements = [
    {
      text: t('work-arrangement-taxonomy-onsite'),
      value: WorkArrangement.ONSITE,
    },
    {
      text: t('work-arrangement-taxonomy-hybrid'),
      value: WorkArrangement.HYBRID,
    },
    {
      text: t('work-arrangement-taxonomy-remote'),
      value: WorkArrangement.REMOTE,
    },
  ];

  const getWorkArrangementText = (value: string | null) => {
    if (value === null) return '';
    return getOptionText(workArrangements, value);
  };

  return { workArrangements, getWorkArrangementText };
};
